<template>
	<div class="know">
		<div class="flex">
			<div class="title">能力点</div>
			<!-- <el-button class="new-create" icon="el-icon-plus" @click="dialogVisible = true">增加分类</el-button> -->
		</div>
		<div class="point">
			<div
				class="point-header"
        _flex="~ justify-center items-center"
				v-if="
					$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
					($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5113_${yy_ms}_1`]))
				"
			>
        <InputTopTip v-model="inputValue" placeholder="输入新能力点，回车添加" :marginTop="10">
          <el-input
            class="point-header-input"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm(inputValue)"
            placeholder=""
            @input="e => inputValue = e.replace(/\s/g, '')"
          >
          </el-input>
            <!-- prefix-icon="el-icon-plus" -->
        </InputTopTip>
        <div _flex="1" _cursor="pointer" _h="30px" @click="isExpand = !isExpand"></div>
        <i
          class="el-icon-arrow-up"
          _transition="duration-300"
          _transform="~ gpu"
          _cursor="pointer"
          @click="isExpand = !isExpand"
          :class="[isExpand ? 'w-rotate-[0deg]' : 'w-rotate-[180deg]']"
        />
			</div>
			<div class="point-context"  :style="{
        height: isExpand ? 'auto' : '0px',
        minHeight: isExpand ? '40px' : '0px',
        padding: isExpand ? '0 11px 13px' : '0px 0px',
        overflowY: isExpand ? 'auto' : 'hidden'
      }">
				<!-- /// 隐藏删除不能单纯直接v-perimssion /// -->
        <el-tooltip v-for="(element, index) in tags" :key="element.id" effect="light" :content="element.knowledge_name" placement="top">
          <el-tag
            :closable="
              $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
              ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5113_${yy_ms}_2`]))
            "
            @close="handleClose(element.id, index)"
            class="tag"
            type="info"
          >
            {{ element.knowledge_name.length >= 20 ? element.knowledge_name.substr(0, 20) + '...' : element.knowledge_name }}
          </el-tag>
        </el-tooltip>
			</div>
		</div>
		<!-- <div v-for="item in tags" :key="item.id">
			<div class="subtitle">{{ item.knowledge_name }}</div>
			<div class="point">
				<div class="point-header">
					<el-input
						class="point-header-input"
						v-model="inputValue[item.id]"
						ref="saveTagInput"
						size="small"
						@keyup.enter.native="handleInputConfirm(item.id, inputValue[item.id])"
						placeholder="输入新能力点，回车添加"
						prefix-icon="el-icon-plus"
					>
					</el-input>
				</div>
				<div class="point-context">
					<el-tag
						v-for="element in item.knowledges"
						:key="element.id"
						closable
						@close="handleClose(element.id)"
						class="tag"
						type="info"
					>
						{{ element.knowledge_name }}
					</el-tag>
				</div>
			</div>
		</div> -->

		<!-- <el-dialog title="新建分类" :visible.sync="dialogVisible" width="30%" :before-close="beforeClose" class="dialog">
			<el-input v-model="classValue" placeholder="分类名称" class="dialog-input"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" :disabled="loading">取 消</el-button>
				<el-button type="primary" @click="confirmClick" :loading="loading">确 定</el-button>
			</span>
		</el-dialog> -->
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
			tags: [],
			inputValue: '',
			classValue: '',
			loading: false,
      sbid: '',
      isExpand: false
		}
	},
	async mounted() {
		const { sbid } =this.$route.params
    this.sbid = sbid
		await this.getPowerPointList()
    if (this.$store.state.user.userInfo.type === this.$api.account.types.OTHER.value) {
      if (!this.$permissions([`SP5113_${this.yy_ms}_1`])) {
        this.isExpand = true
      }
    }
    if (this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value) {
      this.isExpand = true
    }
    if (this.$store.state.user.userInfo.type === this.$api.account.types.SCHOOL_ADMIN.value) {
      this.isExpand = true
    }
	},
  computed: {
		yy_ms() {
			return this.sbid == 1 ? 'yy' : this.sbid == 2 ? 'ms' : ''
		}
	},
	methods: {
		async getPowerPointList() {
			const data = await this.$api.question_set.getPowerPointList({
        fb_subject_id: this.sbid
      })
			this.tags = data
		},
		async beforeClose(done) {
			if (this.loading) return
			done()
		},
		async confirmClick() {
			this.loading = true
			await this.handleInputConfirm(0, this.classValue)
			this.loading = false
			this.dialogVisible = false
		},
		async handleClose(id, index) {
			this.tags.splice(index, 1)
			try {
				await this.deletePowerPointClass(id)
			} catch (err) {
				this.getPowerPointList()
			}
		},
		async handleInputConfirm(knowledge_name) {
			// this.tags.push({
			// 	id: new Date().getTime(),
			// 	pid: 0,
			// 	type: 0,
			// 	knowledge_name: knowledge_name,
			// 	created_at: new Date().getTime(),
			// 	updated_at: new Date().getTime(),
			// 	knowledges: []
			// })
      if (!knowledge_name) return
      if (this.loading) return
			try {
        this.loading = true
				await this.$api.question_set.createPowerPointClass({
					knowledge_name: knowledge_name,
          subject_id: this.sbid
				})
				this.inputValue = ''
				this.getPowerPointList()
        this.loading = false
			} catch (err) {
				this.getPowerPointList()
        this.loading = false
			}
      this.isExpand = true
		},
		async deletePowerPointClass(id) {
			await this.$api.question_set.deletePowerPointClass(id, {})
		}
	}
}
</script>
<style lang="scss" scoped>
.know {
	background: #ffffff;
	border-radius: 12px;
	// padding: 21px;
	margin: 5px;
	padding: 16px;
	border: 2px solid #f5f5fb;
}
.flex {
	display: flex;
	justify-content: space-between;
}
.new-create {
	width: 111px;
	height: 33px;
	line-height: 33px;
	background: #f5f5fb;
	border-radius: 4px 4px 4px 4px;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
}
.dialog {
	/deep/ .el-dialog__title {
		font-size: 18px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #323232;
	}
	/deep/ .el-dialog__body {
		border-top: 2px solid #f8f8f8;
		border-bottom: 2px solid #f8f8f8;
		margin: 1px 20px;
	}
	/deep/ .el-dialog__footer {
		margin-top: 24px;
		margin-bottom: 25px;
	}
}

.dialog-input {
	margin: 38px 0;
}
.title {
	font-size: 20px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: bold;
	color: #3e3e3e;
	margin-bottom: 29px;
}
.subtitle {
	font-size: 16px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #737373;
	margin-bottom: 16px;
}
.point {
	border: 1px #ffffff solid;
	background: #f9fbff;
	margin-bottom: 24px;
}
.point-header {
	border-bottom: 1px #ffffff solid;
	padding: 6px 12px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	border: 2px solid #f5f5fb;
}
.point-context {
	display: flex;
	flex-wrap: wrap;
	align-content: flex-start;
	padding: 11px 13px;
	background: #f9fbff;
	min-height: 199px;
	border-radius: 6px 6px 6px 6px;
}
.point-header-input {
	width: 213px;
	background: #f5f7fa;
	border-radius: 4px 4px 4px 4px;
}
.tag {
	height: 30px;
	background: #e4e8f8;
	border-radius: 4px 4px 4px 4px;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #494949;
	margin-right: 30px;
	margin-top: 8px;
}
</style>
